import React from "react";
import styles from "./ConfirmShippingDeleteModal.module.scss";
import closeButton from "../../../static/icons/close.svg";

import ModalBottomFlexible from "../ModalBottomFlexible";
import Button from "../../Button";

export default ({ isOpened, onClose, onModalClose }) => {
  return (
    <ModalBottomFlexible isOpen={isOpened}>
      <div className={styles.ConfirmDeleteProductModal}>
        <div className={styles.header}>
          <img
            src={closeButton}
            onClick={() => {
              onModalClose();
            }}
          />
        </div>
        <div className={styles.content}>
          <p className={styles.mainMessage}>
            <>Are you sure you want to delete this address?</>
          </p>

          <div className={styles.secondaryMessage}>
            By confirming it will be permanentyly deleted.
          </div>

          <div className={styles.buttonContainer}>
            <Button
              type="button"
              size="large"
              onClick={() => {
                onClose();
                onModalClose();
              }}
              className={styles.confirmButton}
            >
              CONFIRM
            </Button>
          </div>
          <div className={styles.buttonContainer}>
            <Button
              type="button"
              size="large"
              onClick={() => {
                onModalClose();
              }}
              className={styles.cancelButton}
            >
              CANCEL
            </Button>
          </div>
        </div>
      </div>
    </ModalBottomFlexible>
  );
};
